/* 直接促銷同意欄的按鈕閘門（香港 PDPO）。
   未勾選同意前，同一表單的送出鈕停用。checkbox 本身帶 required，
   本檔案載入失敗時瀏覽器原生驗證仍會擋住送出。 */
(function () {
  'use strict';

  function submitsOf(form) {
    return Array.prototype.slice.call(
      form.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]')
    );
  }

  function sync(box) {
    var form = box.form || box.closest('form');
    if (!form) return;
    var ok = box.checked;
    submitsOf(form).forEach(function (b) {
      b.disabled = !ok;
      b.setAttribute('aria-disabled', ok ? 'false' : 'true');
      b.classList.toggle('hk-consent-blocked', !ok);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.hk-consent__box:not([data-hk-consent-init])')
      .forEach(function (box) {
        box.setAttribute('data-hk-consent-init', '1');
        sync(box);
        box.addEventListener('change', function () { sync(box); });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* 彈窗訂閱、快速加購等區塊是後來才插進 DOM 的，需要補綁 */
  if ('MutationObserver' in window) {
    new MutationObserver(function () { init(); })
      .observe(document.documentElement, { subtree: true, childList: true });
  }
})();
